import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TermsOfService() {
  return <div className="min-h-screen w-full bg-heliona-cream font-sans text-heliona-charcoal selection:bg-heliona-mint/30" data-id="element-1066">
      {/* Header */}
      <header className="w-full p-8 flex justify-between items-center max-w-5xl mx-auto" data-id="element-1067">
        <Link to="/" className="flex items-center gap-2 text-heliona-text-gray hover:text-heliona-charcoal transition-colors" data-id="element-1068">
          <ArrowLeft className="w-5 h-5" data-id="element-1069" />
          <span className="text-sm font-medium" data-id="element-1070">Back to Home</span>
        </Link>
        <div className="flex items-center" data-id="element-1071">
          <img src="https://cdn.magicpatterns.com/uploads/gsWfp7Yqa2Z6SBgP3SbdyL/HELIONA_transparent.png" alt="Heliona Logo" className="h-8 sm:h-10" data-id="element-1072" />
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12 sm:py-20" data-id="element-1073">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-1074">
          <h1 className="text-4xl sm:text-5xl font-serif font-medium mb-4 text-heliona-charcoal" data-id="element-1075">
            Terms of Service
          </h1>
          <p className="text-heliona-text-gray mb-12" data-id="element-1076">
            Last updated: February 12, 2026
          </p>

          <div className="prose prose-lg prose-headings:font-serif prose-headings:font-medium prose-headings:text-heliona-charcoal prose-p:text-heliona-text-gray prose-li:text-heliona-text-gray prose-strong:text-heliona-charcoal max-w-none" data-id="element-1077">
            <p data-id="element-1078">
              Please read these Terms of Service ("Terms," "Terms of Service")
              carefully before using the Heliona website and platform (the
              "Service") operated by Heliona ("us," "we," or "our").
            </p>
            <p data-id="element-1079">
              Your access to and use of the Service is conditioned on your
              acceptance of and compliance with these Terms. These Terms apply
              to all visitors, users, and others who access or use the Service.
            </p>

            <h3 data-id="element-1080">1. Acceptance of Terms</h3>
            <p data-id="element-1081">
              By accessing or using the Service, you agree to be bound by these
              Terms. If you disagree with any part of the terms, then you may
              not access the Service.
            </p>

            <h3 data-id="element-1082">2. Use License</h3>
            <p data-id="element-1083">
              Permission is granted to temporarily access the materials
              (information or software) on Heliona's website for personal,
              non-commercial transitory viewing only. This is the grant of a
              license, not a transfer of title, and under this license, you may
              not:
            </p>
            <ul data-id="element-1084">
              <li data-id="element-1085">Modify or copy the materials;</li>
              <li data-id="element-1086">
                Use the materials for any commercial purpose, or for any public
                display (commercial or non-commercial);
              </li>
              <li data-id="element-1087">
                Attempt to decompile or reverse engineer any software contained
                on Heliona's website;
              </li>
              <li data-id="element-1088">
                Remove any copyright or other proprietary notations from the
                materials; or
              </li>
              <li data-id="element-1089">
                Transfer the materials to another person or "mirror" the
                materials on any other server.
              </li>
            </ul>

            <h3 data-id="element-1090">3. User Accounts</h3>
            <p data-id="element-1091">
              When you create an account with us, you must provide us
              information that is accurate, complete, and current at all times.
              Failure to do so constitutes a breach of the Terms, which may
              result in immediate termination of your account on our Service.
            </p>
            <p data-id="element-1092">
              You are responsible for safeguarding the password that you use to
              access the Service and for any activities or actions under your
              password, whether your password is with our Service or a
              third-party service.
            </p>

            <h3 data-id="element-1093">4. Intellectual Property</h3>
            <p data-id="element-1094">
              The Service and its original content (excluding Content provided
              by users), features, and functionality are and will remain the
              exclusive property of Heliona and its licensors. The Service is
              protected by copyright, trademark, and other laws of both the
              United States and foreign countries. Our trademarks and trade
              dress may not be used in connection with any product or service
              without the prior written consent of Heliona.
            </p>

            <h3 data-id="element-1095">5. Termination</h3>
            <p data-id="element-1096">
              We may terminate or suspend access to our Service immediately,
              without prior notice or liability, for any reason whatsoever,
              including without limitation if you breach the Terms.
            </p>
            <p data-id="element-1097">
              All provisions of the Terms which by their nature should survive
              termination shall survive termination, including, without
              limitation, ownership provisions, warranty disclaimers, indemnity,
              and limitations of liability.
            </p>

            <h3 data-id="element-1098">6. Limitation of Liability</h3>
            <p data-id="element-1099">
              In no event shall Heliona, nor its directors, employees, partners,
              agents, suppliers, or affiliates, be liable for any indirect,
              incidental, special, consequential, or punitive damages, including
              without limitation, loss of profits, data, use, goodwill, or other
              intangible losses, resulting from (i) your access to or use of or
              inability to access or use the Service; (ii) any conduct or
              content of any third party on the Service; (iii) any content
              obtained from the Service; and (iv) unauthorized access, use, or
              alteration of your transmissions or content, whether based on
              warranty, contract, tort (including negligence), or any other
              legal theory, whether or not we have been informed of the
              possibility of such damage, and even if a remedy set forth herein
              is found to have failed of its essential purpose.
            </p>

            <h3 data-id="element-1100">7. Governing Law</h3>
            <p data-id="element-1101">
              These Terms shall be governed and construed in accordance with the
              laws of California, United States, without regard to its conflict
              of law provisions.
            </p>

            <h3 data-id="element-1102">8. Changes</h3>
            <p data-id="element-1103">
              We reserve the right, at our sole discretion, to modify or replace
              these Terms at any time. If a revision is material, we will try to
              provide at least 30 days' notice prior to any new terms taking
              effect. What constitutes a material change will be determined at
              our sole discretion.
            </p>

            <h3 data-id="element-1104">9. Contact Us</h3>
            <p data-id="element-1105">
              If you have any questions about these Terms, please contact us at:
            </p>
            <p data-id="element-1106">
              <strong data-id="element-1107">Email:</strong> legal@heliona.co
              <br data-id="element-1108" />
              <strong data-id="element-1109">Address:</strong> 123 Innovation Drive, Suite 400, San
              Francisco, CA 94105
            </p>
          </div>
        </motion.div>
      </main>

      <footer className="w-full py-8 text-center text-sm text-heliona-text-gray/60 border-t border-heliona-charcoal/5 mt-12" data-id="element-1110">
        <div className="max-w-5xl mx-auto px-8 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-1111">
          <p data-id="element-1112">&copy; {new Date().getFullYear()} Heliona. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-1113">
            <Link to="/privacy" className="hover:text-heliona-charcoal transition-colors" data-id="element-1114">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-heliona-charcoal transition-colors" data-id="element-1115">
              Terms of Service
            </Link>
          </div>
        </div>
      </footer>
    </div>;
}